export const GTM_EVENT_NAMES = {
    FIRST_TIME_VISIT: 'fabric:gtm:firstvisit'
};
